export const ignoreUndefinedProperties = <T extends Record<string, any>>(obj: T): Record<string, any> => {
  if (!obj || typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
    return obj
  }

  const result: Record<string, any> = {}

  for (const key of Object.keys(obj)) {
    const value = obj[key]

    if (value === undefined || value === '') {
      result[key] = null
    }
    else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      // Recursively process nested objects only (not arrays)
      result[key] = ignoreUndefinedProperties(value)
    }
    else {
      result[key] = value
    }
  }

  return result
}
